import { createSettingDefaultAction } from "../services/ServiceHelper";
import {
  authenticate,
  activeUser as activeUserService,
} from "../services/LoginService";
import { createActionThunk } from "redux-thunk-actions";
import {
  LOGIN_SET_DEFAULT,
  LOGIN_SUBMIT,
  CHECK_FOR_TODAY_DATA,
} from "./constant";
import { getData } from "../services/DailySummaryService";

const setDefaultState = createSettingDefaultAction(LOGIN_SET_DEFAULT);

const checkForData = createActionThunk(
  CHECK_FOR_TODAY_DATA,
  async (date, userID) => {
    const data = await getData(date, userID);
    return { data };
  }
);

const loginSubmit = createActionThunk(LOGIN_SUBMIT, (user, lang) =>
  authenticate(user, user.isRememberMe, lang)
);

const activeUser = (e, callback) => {
  let data = e;
  return async (dispatch) => {
    try {
      let data = await activeUserService(e);
      callback({ status: true, data });
      return;
    } catch (e) {
      callback({ status: false, data: e });
      return;
    }
  };
};

export default { setDefaultState, loginSubmit, activeUser, checkForData };



// WEBPACK FOOTER //
// ./src/actions/homeActions.js